



























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import ventasCabeceraModule from "@/store/modules/ventas_cabecera-module";
import clientsModule from "@/store/modules/client-module";
import tiendaCartModule from "@/store/modules/tienda_cart_module";
import { ventas_cabecera } from "@/shared/dtos/ventas_cabecera";
import { ventas_lineas } from "@/shared/dtos/ventas_lineas";
import { PdfCorporateService } from "@/shared/services/pdf-corporate.service";
import PublicarWpPopup from "@/components/wordpress/PublicarWpPopup.vue";
import { lecturas_codigo_barras } from "@/shared/dtos/lecturas_codigo_barras";
import lecturas_codigo_barrasModule from "@/store/modules/lecturas_codigo_barras-module";
import ocultarcamposModule from "@/store/modules/ocultarcampos-module";
import productoModule from "@/store/modules/producto-module";
import { ProcessoNums } from "@/views/procesos/ProcessoNums";
import { MessageService } from "@/shared/services/message-service";

@Component({ components: { PublicarWpPopup } })
export default class VentasCabeceraFormulario extends Vue {
  saving = false;
  lineas: ventas_lineas[] = [];
  lineasEliminadas: number[] = [];
  venta: ventas_cabecera = new ventas_cabecera();
  precioEnvio: number = 0;
  mostrarPopupWp = false;
  dialogCarrito = false;
  busquedaCarrito = "";
  carritosList: any[] = [];

  tiposDocumento = ["presupuesto", "factura", "albarán"];
  estadoOpciones = ["borrador", "enviado", "confirmado", "cancelado"];

  popupEscaner = false;
  lpnInput = "";
  scannerEstado: "idle" | "buscando" | "encontrado" | "noEncontrado" = "idle";
  ultimoProductoAnadido: ventas_lineas | null = null;
  historialEscaneos: Array<{ lpn: string; ok: boolean; titulo: string }> = [];

  lightboxAbierto = false;
  lightboxSrc = "";

  // Confirmar Venta
  showVentaDialog = false;
  pasoVenta: number = 1;  // 1=metodo_pago, 2=resumen(avanzado), 3=procesando/resultado
  tipoVenta: number = 0;
  vendandoLoading = false;
  resultadoVenta: { vendidos: number[]; errores: number[]; sin_producto: number } | null = null;

  get isNew() {
    return (this as any).$route.params.id === "nuevo";
  }

  get tipoLabel() {
    const t = this.venta.tipo_documento || "documento";
    return t.charAt(0).toUpperCase() + t.slice(1);
  }

  get clientesList() {
    return clientsModule.clientses.map((c) => ({
      text: (c.name || "") + (c.email ? " — " + c.email : ""),
      value: c.id,
    }));
  }

  get clienteInfo() {
    if (!this.venta.client_id) return null;
    return (
      clientsModule.clientses.find((c) => c.id === this.venta.client_id) || null
    );
  }

  get scannerColor() {
    const mapa: Record<string, string> = {
      idle: "#3b82f6",
      buscando: "#f59e0b",
      encontrado: "#27ae60",
      noEncontrado: "#e53e3e",
    };
    return mapa[this.scannerEstado] || "#3b82f6";
  }

  get scannerHeaderClass() {
    const mapa: Record<string, string> = {
      idle: "scanner-header--blue",
      buscando: "scanner-header--yellow",
      encontrado: "scanner-header--green",
      noEncontrado: "scanner-header--red",
    };
    return mapa[this.scannerEstado] || "scanner-header--blue";
  }

  get scannerStatusText() {
    const mapa: Record<string, string> = {
      idle: "Listo para escanear",
      buscando: "Buscando producto…",
      encontrado: "¡Añadido!",
      noEncontrado: "LPN no encontrado en el sistema",
    };
    return mapa[this.scannerEstado] || "";
  }

  get totalAmazon() {
    return this.lineas.reduce(
      (s, l) => s + (Number(l.precio_amazon) || 0) * (Number(l.cantidad) || 1),
      0,
    );
  }

  get totalVenta() {
    return this.lineas.reduce((s, l) => s + (Number(l.total_linea) || 0), 0);
  }

  get totalCoste() {
    return this.lineas.reduce(
      (s, l) => s + (Number(l.coste_unitario) || 0) * (Number(l.cantidad) || 1),
      0,
    );
  }

  get totalNeto() {
    return this.totalVenta - this.totalCoste;
  }

  get margenMedio() {
    if (this.totalAmazon === 0) return 0;
    return (this.totalVenta / this.totalAmazon) * 100;
  }

  get totalPeso(): number {
    return this.lineas.reduce(
      (s, l) => s + (Number(l.peso) || 0) * (Number(l.cantidad) || 1),
      0,
    );
  }

  get importeIva(): number {
    return this.totalVenta * ((Number(this.venta.iva) || 0) / 100);
  }

  get importeRecargo(): number {
    return (
      this.totalVenta * ((Number(this.venta.recargo_equivalencia) || 0) / 100)
    );
  }

  get totalConImpuestos(): number {
    return this.totalVenta + this.importeIva + this.importeRecargo;
  }

  get totalFinal(): number {
    return this.totalConImpuestos + (Number(this.precioEnvio) || 0);
  }

  get tieneLineasConProducto() {
    return this.lineas.some((l: ventas_lineas) => l.id_producto);
  }

  get itemsParaWp() {
    return this.lineas.map((l) => ({
      titulo: l.descripcion || "Producto",
      qty: l.cantidad || 1,
      precio_amazon: l.precio_amazon || 0,
      // Precio de venta real = total_linea / cantidad (ya incluye el descuento aplicado)
      precio_venta:
        (Number(l.cantidad) || 1) > 0
          ? Math.round(
              (Number(l.total_linea) / (Number(l.cantidad) || 1)) * 100,
            ) / 100
          : Math.round(
              Number(l.precio_unitario) *
                (1 - (Number(l.descuento) || 0) / 100) *
                100,
            ) / 100,
      imagen: l.imagen_url,
    }));
  }

  get carritosFiltrados(): any[] {
    const q = this.busquedaCarrito.trim().toLowerCase();
    if (!q) return this.carritosList;
    return this.carritosList.filter((c: any) => {
      const uid =
        c.cart && c.cart.public_uid
          ? String(c.cart.public_uid).toLowerCase()
          : "";
      const name = c.client && c.client.name ? c.client.name.toLowerCase() : "";
      const email =
        c.client && c.client.email ? c.client.email.toLowerCase() : "";
      return uid.includes(q) || name.includes(q) || email.includes(q);
    });
  }

  async created() {
    await clientsModule.getclientses();
    if (!this.isNew) {
      const id = Number((this as any).$route.params.id);
      await ventasCabeceraModule.getVenta(id);
      this.venta = ventasCabeceraModule.venta;
      this.precioEnvio = Number(this.venta.precio_envio) || 0;
      await ventasCabeceraModule.getLineasByCabecera(id);
      this.lineas = ventasCabeceraModule.lineas.slice();
      this.$nextTick(() => {
        this.lineas.forEach((l) => {
          if (l.imagen_url && !l.base64) {
            this.loadBase64Image(l.imagen_url).then((b64) => {
              if (b64) l.base64 = b64;
            });
          }
        });
      });
    } else {
      this.venta.tipo_documento = "presupuesto";
      this.venta.estado = "borrador";
      this.venta.iva = 21;
      this.venta.recargo_equivalencia = 0;
      this.venta.precio_envio = 0;
      const qClientId = Number((this as any).$route.query.client_id);
      if (qClientId) this.venta.client_id = qClientId;
      await tiendaCartModule.getAllCarts();
      this.carritosList = tiendaCartModule.allCarts.slice();
      const qCarritoId = Number((this as any).$route.query.id_carrito);
      if (qCarritoId) {
        const entry = this.carritosList.find(
          (c: any) => c.cart && c.cart.id === qCarritoId,
        );
        if (entry) this.seleccionarCarrito(entry);
      }
    }
  }

  recalcularLinea(l: ventas_lineas) {
    const p = Number(l.precio_unitario) || 0;
    const d = Number(l.descuento) || 0;
    const q = Number(l.cantidad) || 1;
    l.total_linea = Math.round(p * q * (1 - d / 100) * 100) / 100;
  }

  eliminarLinea(index: number) {
    const l = this.lineas[index];
    if (l.id) {
      this.lineasEliminadas.push(l.id);
    }
    this.lineas.splice(index, 1);
  }

  addEmptyLine() {
    const l = new ventas_lineas();
    l.cantidad = 1;
    l.precio_amazon = 0;
    l.precio_unitario = 0;
    l.coste_unitario = 0;
    l.descuento = 0;
    l.total_linea = 0;
    l.peso = 0;
    this.lineas.push(l);
  }

  abrirEscaner() {
    this.popupEscaner = true;
    this.resetEscaner();
    this.$nextTick(() => {
      const ref = this.$refs.scannerInput as any;
      if (ref && ref.focus) ref.focus();
    });
  }

  cerrarEscaner() {
    this.popupEscaner = false;
    this.resetEscaner();
    this.historialEscaneos = [];
  }

  resetEscaner() {
    this.lpnInput = "";
    this.scannerEstado = "idle";
    this.ultimoProductoAnadido = null;
    this.$nextTick(() => {
      const ref = this.$refs.scannerInput as any;
      if (ref && ref.focus) ref.focus();
    });
  }

  async buscarPorLpn() {
    const lpn = (this.lpnInput || "").trim();
    if (!lpn) return;

    this.scannerEstado = "buscando";
    this.ultimoProductoAnadido = null;

    const lectura = new lecturas_codigo_barras();
    lectura.referencia = lpn;
    lectura.dispositivo = "VentasFormulario";
    lecturas_codigo_barrasModule.guardarlecturas_codigo_barras(lectura);

    try {
      const { ssmHttpService } = await import("@/shared/services/http-service");
      const { API } = await import("@/shared/api");
      const prod = (await ssmHttpService.get(
        API.productoByLpn + encodeURIComponent(lpn),
        null,
        false,
      )) as any;

      if (!prod || !prod.lpn) {
        throw new Error("vacio");
      }

      const nuevaLinea = new ventas_lineas();
      nuevaLinea.id_producto = prod.id || null;
      nuevaLinea.descripcion = prod.item_desc || prod.titulo_producto || lpn;
      nuevaLinea.imagen_url =
        prod.hiRes ||
        prod.large ||
        prod.medium_image ||
        prod.image_url ||
        prod.thumb ||
        "";
      nuevaLinea.cantidad = 1;
      nuevaLinea.precio_amazon = Number(
        prod.unit_retail || prod.precio_amazon || 0,
      );
      // Precio de venta por defecto al 80% del precio Amazon
      nuevaLinea.precio_unitario =
        Math.round(nuevaLinea.precio_amazon * 0.8 * 100) / 100;
      nuevaLinea.coste_unitario = Number(prod.coste_compra || prod.coste || 0);
      nuevaLinea.descuento = 0;
      nuevaLinea.total_linea = nuevaLinea.precio_unitario;
      nuevaLinea.peso = this.parsePeso(
        prod.item_pkg_weight
          ? prod.item_pkg_weight + " " + (prod.item_pkg_weight_uom || "GR")
          : prod.peso,
      );

      this.lineas.push(nuevaLinea);
      this.ultimoProductoAnadido = nuevaLinea;
      this.scannerEstado = "encontrado";
      this.historialEscaneos.push({
        lpn,
        ok: true,
        titulo: nuevaLinea.descripcion,
      });
      this._beep(true);

      if (nuevaLinea.imagen_url) {
        this.loadBase64Image(nuevaLinea.imagen_url).then((b64) => {
          if (b64) nuevaLinea.base64 = b64;
        });
      }

      setTimeout(() => this.resetEscaner(), 1200);
    } catch {
      this.scannerEstado = "noEncontrado";
      this.historialEscaneos.push({ lpn, ok: false, titulo: "" });
      this._beep(false);
      this.$nextTick(() => {
        const ref = this.$refs.scannerInput as any;
        if (ref && ref.$el) {
          const input = ref.$el.querySelector("input");
          if (input) input.select();
        }
      });
    }
  }

  addEmptyLineFromScanner() {
    const lpn = this.lpnInput.trim();
    const l = new ventas_lineas();
    l.descripcion = lpn ? "LPN: " + lpn : "";
    l.cantidad = 1;
    l.precio_amazon = 0;
    l.precio_unitario = 0;
    l.coste_unitario = 0;
    l.descuento = 0;
    l.total_linea = 0;
    l.peso = 0;
    this.lineas.push(l);
    this.historialEscaneos.push({
      lpn,
      ok: false,
      titulo: "(línea vacía: " + lpn + ")",
    });
    this.resetEscaner();
  }

  _beep(ok: boolean) {
    try {
      const ctx = new (window.AudioContext ||
        (window as any).webkitAudioContext)();
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.value = ok ? 880 : 330;
      osc.type = "sine";
      gain.gain.setValueAtTime(0.3, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.2);
      osc.start(ctx.currentTime);
      osc.stop(ctx.currentTime + 0.2);
    } catch {
      // AudioContext puede no estar disponible
    }
  }

  abrirLightbox(src: string) {
    this.lightboxSrc = src;
    this.lightboxAbierto = true;
  }

  parsePeso(valor: any): number {
    if (!valor && valor !== 0) return 0;
    if (typeof valor === "number") {
      if (isNaN(valor)) return 0;
      return valor > 200 ? valor / 1000 : valor;
    }
    const str = String(valor)
      .toLowerCase()
      .trim();
    if (!str) return 0;
    const match = str.match(/([0-9]+(?:[.,][0-9]+)?)/);
    if (!match) return 0;
    const num = parseFloat(match[1].replace(",", "."));
    if (isNaN(num)) return 0;
    if ((str.includes(" g") || str.includes("gr")) && !str.includes("kg"))
      return num / 1000;
    if (num > 200 && !str.includes("kg")) return num / 1000;
    return num;
  }

  onPublicado(resultado: any) {
    console.log("Publicado en WordPress:", resultado);
  }

  seleccionarCarrito(entry: any) {
    this.dialogCarrito = false;
    this.busquedaCarrito = "";
    this.venta.id_carrito_origen = entry.cart ? entry.cart.id : null;
    if (entry.client && entry.client.id) this.venta.client_id = entry.client.id;
    const items: any[] = entry.items || [];
    this.lineas = items.map((item: any) => {
      const prod = item.producto_amazon || item.product_snapshot || {};
      const l = new ventas_lineas();
      l.id_producto = prod.id || null;
      l.descripcion =
        prod.item_desc || prod.titulo_producto || prod.titulo || "";
      l.imagen_url =
        prod.hiRes || prod.large || prod.medium_image || prod.image_url || prod.thumb || "";
      l.cantidad = Number(item.cantidad) || 1;
      l.precio_amazon = Number(prod.unit_retail || prod.precio_amazon || 0);
      // Precio de venta por defecto al 80% del precio Amazon
      l.precio_unitario = Math.round(l.precio_amazon * 0.8 * 100) / 100;
      l.coste_unitario = Number(prod.coste_compra || prod.coste || 0);
      l.descuento = 0;
      l.total_linea = l.precio_unitario * l.cantidad;
      l.peso = this.parsePeso(
        prod.item_pkg_weight
          ? prod.item_pkg_weight + " " + (prod.item_pkg_weight_uom || "GR")
          : prod.peso,
      );
      return l;
    });
    this.$nextTick(() => {
      this.lineas.forEach((l) => {
        if (l.imagen_url && !l.base64) {
          this.loadBase64Image(l.imagen_url).then((b64) => {
            if (b64) l.base64 = b64;
          });
        }
      });
    });
  }

  abrirConfirmarVenta() {
    this.resultadoVenta = null;
    this.pasoVenta = 1;
    this.tipoVenta = 0;
    this.showVentaDialog = true;
    if (ocultarcamposModule.Ocultar_tarjeta_efectivo) {
      this.tipoVenta = ProcessoNums.VendidoTarjeta;
      this.pasoVenta = ocultarcamposModule.mostrar_campos_coste ? 2 : 3;
      if (this.pasoVenta === 3) this.ejecutarVenta();
    }
  }

  seleccionarPago(tipo: number) {
    this.tipoVenta = tipo;
    this.pasoVenta = ocultarcamposModule.mostrar_campos_coste ? 2 : 3;
    if (this.pasoVenta === 3) this.ejecutarVenta();
  }

  async ejecutarVenta() {
    this.pasoVenta = 3;
    this.vendandoLoading = true;
    try {
      this.resultadoVenta = await productoModule.venderVenta({
        ventaId: this.venta.id,
        metodo_pago: this.tipoVenta,
      });
      if (this.resultadoVenta && this.resultadoVenta.vendidos.length > 0) {
        MessageService.toast(
          this.resultadoVenta.vendidos.length + " productos vendidos correctamente"
        );
      }
    } finally {
      this.vendandoLoading = false;
    }
  }

  cerrarVentaDialog() {
    this.showVentaDialog = false;
  }

  async guardar() {
    this.venta.base_imponible = this.totalVenta;
    this.venta.total_amazon = this.totalAmazon;
    this.venta.total_coste = this.totalCoste;
    this.venta.beneficio_neto = this.totalNeto;
    this.venta.margen_medio = this.margenMedio;
    this.venta.iva = Number(this.venta.iva) || 0;
    this.venta.recargo_equivalencia =
      Number(this.venta.recargo_equivalencia) || 0;
    this.venta.precio_envio = Number(this.precioEnvio) || 0;
    this.venta.impuestos = this.importeIva + this.importeRecargo;
    this.venta.total = this.totalFinal;

    this.saving = true;
    try {
      const saved = (await ventasCabeceraModule.guardarVenta(
        this.venta,
      )) as any;
      const cabeceraId = saved && saved.id ? saved.id : this.venta.id;

      for (const id of this.lineasEliminadas) {
        await ventasCabeceraModule.eliminarLinea(id);
      }
      this.lineasEliminadas = [];

      for (const linea of this.lineas) {
        linea.id_cabecera = cabeceraId;
        await ventasCabeceraModule.guardarLinea(linea);
      }

      (this as any).$router.go(-1);
    } finally {
      this.saving = false;
    }
  }

  async loadBase64Image(url: string): Promise<string> {
    if (!url) return "";
    try {
      const resp = await fetch(url, { mode: "cors" });
      if (resp.ok) {
        const blob = await resp.blob();
        return await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = () => resolve("");
          reader.readAsDataURL(blob);
        });
      }
    } catch (_) {
      /* continuar con fallback */
    }
    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.naturalWidth || img.width;
        canvas.height = img.naturalHeight || img.height;
        const ctx = canvas.getContext("2d");
        if (ctx) {
          ctx.drawImage(img, 0, 0);
          try {
            resolve(canvas.toDataURL("image/jpeg"));
          } catch (e) {
            resolve("");
          }
        } else {
          resolve("");
        }
      };
      img.onerror = () => resolve("");
      img.src = url;
    });
  }

  async imprimir() {
    this.saving = true;
    try {
      for (let l of this.lineas) {
        if (l.imagen_url && !l.base64) {
          l.base64 = await this.loadBase64Image(l.imagen_url);
        }
      }

      const columns = [
        { header: "Foto", width: 18, align: "center" as "center" },
        { header: "Artículo" },
        { header: "Cant.", width: 14, align: "center" as "center" },
        { header: "P. Amazon", width: 28, align: "right" as "right" },
        { header: "Precio Venta", width: 28, align: "right" as "right" },
        { header: "Dto. %", width: 20, align: "right" as "right" },
        { header: "Total línea", width: 28, align: "right" as "right" },
      ];

      const rows: any[] = this.lineas.map((l) => [
        "",
        l.descripcion,
        String(l.cantidad || 1),
        Number(l.precio_amazon).toFixed(2) + " €",
        Number(l.precio_unitario).toFixed(2) + " €",
        (l.descuento || 0) + " %",
        Number(l.total_linea).toFixed(2) + " €",
      ]);
      rows.push([
        "",
        "SUBTOTAL (Base Imponible)",
        "",
        this.totalAmazon.toFixed(2) + " €",
        this.totalVenta.toFixed(2) + " €",
        this.margenMedio.toFixed(1) + " %",
        this.totalVenta.toFixed(2) + " €",
      ]);

      const result = await PdfCorporateService.createDoc({
        title: this.isNew
          ? "Nuevo " + this.venta.tipo_documento
          : this.tipoLabel + " #" + this.venta.id,
        clientInfo: this.clienteInfo || undefined,
        note: this.venta.notas || undefined,
      });

      const finalY = PdfCorporateService.addTable(
        result.doc,
        columns,
        rows,
        result.contentY,
        {
          totalsRowIndex: rows.length - 1,
          minCellHeight: 16,
          didDrawCell: (data: any) => {
            const linea = this.lineas[data.row.index];
            if (
              data.column.index === 0 &&
              data.cell.section === "body" &&
              linea
            ) {
              const base64 = linea.base64;
              if (base64) {
                try {
                  result.doc.addImage(
                    base64,
                    "JPEG",
                    data.cell.x + 2,
                    data.cell.y + 1,
                    14,
                    14,
                  );
                } catch (e) {}
              }
            }
          },
        },
      );

      const doc = result.doc;
      const pageW = doc.internal.pageSize.getWidth();
      let y = finalY + 8;

      if (this.totalPeso > 0) {
        doc.setFillColor(235, 243, 255);
        doc.roundedRect(8, y, pageW - 16, 10, 2, 2, "F");
        doc.setTextColor(59, 130, 246);
        doc.setFontSize(8.5);
        doc.setFont("helvetica", "bold");
        doc.text("Peso total estimado del envío:", 12, y + 6.5);
        doc.setFont("helvetica", "normal");
        doc.text(this.totalPeso.toFixed(2) + " kg", pageW - 12, y + 6.5, {
          align: "right",
        });
        y += 14;
      }

      const tieneImpuestos =
        Number(this.venta.iva) > 0 ||
        Number(this.venta.recargo_equivalencia) > 0;
      if (tieneImpuestos) {
        const lineasImp: string[] = [];
        lineasImp.push("Base imponible: " + this.totalVenta.toFixed(2) + " €");
        if (Number(this.venta.iva) > 0)
          lineasImp.push(
            "IVA (" +
              this.venta.iva +
              "%): + " +
              this.importeIva.toFixed(2) +
              " €",
          );
        if (Number(this.venta.recargo_equivalencia) > 0)
          lineasImp.push(
            "Recargo de equivalencia (" +
              this.venta.recargo_equivalencia +
              "%): + " +
              this.importeRecargo.toFixed(2) +
              " €",
          );
        lineasImp.push("---------------------------------");
        lineasImp.push(
          "Total artículos: " + this.totalConImpuestos.toFixed(2) + " €",
        );

        const aplicaRecargo = Number(this.venta.recargo_equivalencia) > 0;
        const notaRecargo = aplicaRecargo
          ? "* Recargo de equivalencia: régimen especial de IVA para comerciantes minoristas.\n  El proveedor lo ingresa directamente a Hacienda en nombre del comprador."
          : null;
        const notaLineas = notaRecargo
          ? doc.splitTextToSize(notaRecargo, pageW - 28)
          : [];
        const boxH =
          10 +
          lineasImp.length * 5.5 +
          (notaLineas.length > 0 ? 4 + notaLineas.length * 4 : 0);

        doc.setFillColor(245, 245, 245);
        doc.roundedRect(8, y, pageW - 16, boxH, 2, 2, "F");
        doc.setTextColor(80, 80, 80);
        doc.setFontSize(8);
        doc.setFont("helvetica", "bold");
        doc.text("Desglose de impuestos", 12, y + 6);
        doc.setFont("helvetica", "normal");
        lineasImp.forEach((linea, i) => {
          if (linea.startsWith("Total ")) {
            doc.setFont("helvetica", "bold");
            doc.setTextColor(40, 40, 40);
          } else if (linea.startsWith("----")) {
            doc.setTextColor(180, 180, 180);
          } else {
            doc.setFont("helvetica", "normal");
            doc.setTextColor(80, 80, 80);
          }
          doc.text(linea, 12, y + 10.5 + i * 5.5);
        });
        if (notaLineas.length > 0) {
          const notaY = y + 10.5 + lineasImp.length * 5.5 + 3;
          doc.setFont("helvetica", "italic");
          doc.setFontSize(6.5);
          doc.setTextColor(140, 140, 140);
          doc.text(notaLineas, 12, notaY);
        }
        y += boxH + 4;
      }

      const envio = Number(this.precioEnvio) || 0;
      const esGratis = envio <= 0;
      const totalConEnvio = this.totalFinal;

      if (esGratis) {
        doc.setFillColor(4, 120, 87);
        doc.roundedRect(8, y, pageW - 16, 16, 2, 2, "F");
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");
        doc.text("✨  ENVÍO TOTALMENTE GRATIS", 12, y + 10);
        doc.text("0.00 €", pageW - 12, y + 10, { align: "right" });
        y += 20;
        doc.setFillColor(209, 250, 229);
        doc.roundedRect(8, y, pageW - 16, 10, 2, 2, "F");
        doc.setTextColor(6, 78, 59);
        doc.setFontSize(8);
        doc.setFont("helvetica", "italic");
        doc.text(
          "¡Tu pedido incluye envío gratis! Sin coste adicional en la entrega.",
          12,
          y + 6.5,
        );
        y += 14;
      } else {
        doc.setFillColor(245, 158, 11);
        doc.roundedRect(8, y, pageW - 16, 16, 2, 2, "F");
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");
        doc.text("🚚  ENVÍO POR SOLO " + envio.toFixed(2) + " €", 12, y + 10);
        doc.text("+ " + envio.toFixed(2) + " €", pageW - 12, y + 10, {
          align: "right",
        });
        y += 20;
      }

      doc.setFillColor(230, 246, 240);
      doc.roundedRect(8, y, pageW - 16, 26, 2, 2, "F");
      doc.setTextColor(0, 133, 74);
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("Rentabilidad y Ahorro Estimado", 12, y + 7);
      doc.setTextColor(60, 60, 60);
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      const rendimiento = this.totalAmazon - this.totalVenta;
      doc.text(
        "Valor en tienda (Amazon): " +
          this.totalAmazon.toFixed(2) +
          " €. Con Outlet pagas (Base Imponible): " +
          this.totalVenta.toFixed(2) +
          " €.\n¡Tienes un rendimiento estimado para la reventa de " +
          rendimiento.toFixed(2) +
          " €!",
        12,
        y + 14,
      );
      y += 30;

      doc.setFillColor(0, 133, 74);
      doc.roundedRect(8, y, pageW - 16, 16, 2, 2, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(11);
      doc.setFont("helvetica", "bold");
      let impExtra = "";
      if (Number(this.venta.iva) > 0)
        impExtra += "IVA " + this.venta.iva + "% ";
      if (Number(this.venta.recargo_equivalencia) > 0) {
        if (impExtra) impExtra += "+ ";
        impExtra += "R.Eq. " + this.venta.recargo_equivalencia + "% ";
      }
      if (esGratis) {
        if (impExtra) impExtra += "+ ";
        impExtra += "envío gratis ";
      } else if (envio > 0) {
        if (impExtra) impExtra += "+ ";
        impExtra += "envío " + envio.toFixed(2) + "€ ";
      }
      const labelTotal = impExtra
        ? "TOTAL A PAGAR (" + impExtra.trim() + " incluido)"
        : "TOTAL A PAGAR";
      doc.text(labelTotal, 12, y + 10);
      doc.setFontSize(12);
      doc.text(totalConEnvio.toFixed(2) + " €", pageW - 12, y + 10, {
        align: "right",
      });

      PdfCorporateService.save(
        doc,
        this.venta.tipo_documento + "_" + (this.venta.id || "nuevo"),
      );
    } catch (e) {
      alert("Error al generar PDF: " + ((e as any).message || e));
    } finally {
      this.saving = false;
    }
  }
}
